import { REGISTRATION_STATUSES } from 'api/auth/constants'

export const statusBadge = {
  [REGISTRATION_STATUSES.REVIEW]: 'warning',
  [REGISTRATION_STATUSES.REQUESTED]: 'error',
  [REGISTRATION_STATUSES.APPROVED]: 'ok',
  [REGISTRATION_STATUSES.REJECTED]: 'error',
}
